import axios from "axios";
import { Base_URL } from "../url";

export const fetchBudgetMasters = async () => {
  try {
    const response = await axios.get(`${Base_URL}/BudgetMaster`);
    //const response = await axios.get("https://192.168.29.243:7039/api/BudgetMaster");
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching budget masters!";
  }
};